import { EventAggregator } from "aurelia-event-aggregator";
import { PLATFORM, useView } from "aurelia-framework";
import { Router } from "aurelia-router";
import config from "../../common/config";
import { OidcSignInRedirectCallback, UserLoaded } from "../../common/oidc/oidc-event-handler";
import type { ILocationSave } from "./sign-in-start";

@useView(PLATFORM.moduleName("./sign-in-view.html"))
export class SignInRedirectPage {
    private _router: Router;
    public _ea: EventAggregator;

    public constructor(ea: EventAggregator, router: Router) {
        this._ea = ea;
        this._router = router;

        this._ea.subscribeOnce(UserLoaded, () => this.userLoaded());
    }

    public async activate() {
        let location = window.location.toString();
        console.log("[OIDC] Publishing redirect sign-in callback.", window.location.pathname);
        this._ea.publish(OidcSignInRedirectCallback, location);
    }

    private async userLoaded() {
        let saveJson = window.sessionStorage.getItem(config.locationSaveKey);
        let save: ILocationSave = JSON.parse(saveJson) || {};
        console.log(`Restoring saved location:`, save);
        this._router.navigate(save.fragment + "?" + save.query);
    }
}
